import * as React from 'react';

export const useNumberInput = (
  setter: React.Dispatch<React.SetStateAction<number>>,
) => {
  return React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const val = e.target.value;
      setter(val === '' ? 0 : Number(val));
    },
    [setter],
  );
};
